export const CUSTOMER_STATUS_ACTIVE = "active";
export const CUSTOMER_STATUS_INACTIVE = "inactive";

export const CUSTOMER_STATUSES = [
  CUSTOMER_STATUS_ACTIVE,
  CUSTOMER_STATUS_INACTIVE,
] as const;
